export default __webpack_public_path__ + "static/media/Facebook.c151f4f0.svg";